import { SuperAgentResource } from './resource';

export { SuperagentResponse } from './resource';
export default SuperAgentResource;